
import { defineComponent } from "vue";
import { PatientModel } from "@/domain/models";
import { mapState } from "vuex"

type ComponentData = {
  selected_label?: string;
  patient?: PatientModel;
  text_search: string;
  validation_message?: string;
  show_options: boolean;
};

export default defineComponent({
  name: "SelectSearchPatient",
  data(): ComponentData {
    return {
      show_options: false,
      patient: undefined,
      validation_message: undefined,
      text_search: "",
    };
  },
  created() {
    this.$store.dispatch("cache/updateCachePatients")
    this.patient = this.patients.find((p: PatientModel) => p.id == this.modelValue);
    if (this.patient) this.text_search = this.patient.name;
  },
  computed: {
    ...mapState("cache", ["patients"]),
    options(): PatientModel[] {
      return this.patients.filter((p: PatientModel) =>
        p.name.match(new RegExp(this.text_search, "i"))
      );
    },
  },
  props: {
    modelValue: Number,
    name: String,
    label: String,
    empty_message: String,
    readonly: Boolean,
    manual_focus: Boolean,
    required: Boolean,
  },
  emits: ["update:modelValue", "updateValidation"],
  methods: {
    setSelected(selected_patient: PatientModel) {
      this.$emit("update:modelValue", selected_patient.id);
      this.patient = selected_patient;
      this.hide();
      this.validate();
    },
    show() {
      this.text_search = "";
      this.show_options = true;
    },
    hide() {
      this.text_search = this.patient?.name || "";
      this.show_options = false;
      this.validate();
    },
    reset() {
      this.patient = undefined;
      this.$emit("update:modelValue", undefined);
      this.text_search = "";
      this.hide();
      this.validate();
    },
    validate() {
      if (this.required && !this.patient)
        this.validation_message = "Paciente obrigatório";
      else this.validation_message = undefined;
      this.$emit(
        "updateValidation",
        this.name,
        !!this.patient || !this.required
      );
    },
  },
  watch: {
    modelValue(id: number) {
      this.patient = this.patients.find((p: PatientModel) => p.id == id);
      if (this.patient) this.text_search = this.patient.name;
    },
    patients(patients: PatientModel[]){
      this.patient = patients.find((p) => p.id == this.modelValue);
      if (this.patient) this.text_search = this.patient.name;
    }
  },
});
